var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgFigure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 541,
    height: 482,
    viewBox: "0 0 541 482",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M405.741 0.868408H135.247L0 241.331L135.247 481.753H405.741L540.988 241.331L405.741 0.868408ZM353.429 388.791H187.546L104.611 241.331L187.546 93.8571H353.429L436.378 241.331L353.429 388.791Z",
    fill: "#D9D889",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFigure);
export default __webpack_public_path__ + "static/media/bg_figure.7f29b7bc6f5bb93fe0c4508f013f8d1e.svg";
export { ForwardRef as ReactComponent };